import { observer } from "mobx-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Input from "../../Common/Forms/Input";
import ButtonPrimary from "../../Common/Buttons/ButtonPrimary";
import toast from "react-hot-toast";
import BaseCard from "../../Common/Cards/BaseCard";
import { globalStores } from "../../api/globalStores";
import Avatar from "../../Common/Avatars/Avatar";
import { Child } from "../../api/child";
import Modal from "../../Common/Utility/Modal";

export default observer(OnboardingFlow);

function OnboardingFlow() {
  return (
    <>
      {/* DESKTOP VIEW */}

      <div className="hidden bg-brij-Default w-full h-full lg:flex relative bg-hill_children bg-contain bg-no-repeat bg-bottom backdrop-opacity-50">
        <div className="p-14 flex w-full justify-center z-10">
          <div className="flex-col flex justify-center">
            <BaseCard>
              <div className="inline-flex flex-col gap-3 w-full">
                <StudentLogin />
              </div>
            </BaseCard>
          </div>
        </div>
      </div>

      {/* MOBILE VIEW */}

      <div className="lg:hidden flex flex-col gap-2 items-center bg-brij-Default h-screen relative bg-playground bg-contain bg-no-repeat bg-bottom backdrop-opacity-50 w-full p-8 justify-start overflow-y-scroll">
        <div className="flex flex-col gap-3 w-full">
          <StudentLogin />
        </div>
      </div>
    </>
  );
}

const StudentLogin = observer(() => {
  const navigate = useNavigate();
  const [passCode, setPassCode] = useState<number | undefined>();
  const [newPassCode, setNewPassCode] = useState<number>(0);
  const [parentPassword, setParentPassword] = useState<string>("");
  const [openChangePassDialog, setOpenChangePassDialog] = useState(false);

  const submitChildDetails = async () => {
    if (!passCode) {
      throw new Error("Please enter a passcode first!");
    }

    if (globalStores.childStore.checkPasscode(passCode)) {
      navigate("/student/dashboard");
    } else {
      throw new Error("Wrong Passcode");
    }
  };

  const handleUpdatePassCode = () => {
    setOpenChangePassDialog(false);
    toast.promise(
      globalStores.childStore.updatePasscode(parentPassword, newPassCode),
      {
        success: "Password updated!",
        error: (e) => e.message,
        loading: "Updating Child Passcode",
      }
    );
  };

  return (
    <>
      <Modal
        open={openChangePassDialog}
        onClose={() => setOpenChangePassDialog(false)}
      >
        <BaseCard title="Change Passcode">
          <div className="w-full inline-flex flex-col gap-3">
            {/* TODO: Set start date and end date labels @stephen */}
            <Input
              type="password"
              placeholder="Parent Password"
              onChange={(val) => setParentPassword(val)}
            />
            <Input
              type="number"
              placeholder="New Child Passcode"
              onChange={(val) => setNewPassCode(+val)}
            />
          </div>
          <ButtonPrimary onClick={handleUpdatePassCode}>
            Change Passcode
          </ButtonPrimary>
        </BaseCard>
      </Modal>
      <div className="inline-flex items-center justify-center">
        <div className="flex h-44 w-[134px] flex-col items-center justify-center gap-[18px] overflow-clip rounded-xl p-3">
          <div className="h-20 w-20">
            <Avatar
              large
              icon={Child.getIcon(globalStores.childStore)}
              active={false}
            />
          </div>
          <div className="flex flex-col items-center justify-center gap-1">
            <p className="h-5 w-[110px] text-center font-['Poppins'] text-lg font-medium leading-[1.35] text-[rgba(109,109,109,1)]">
              {globalStores.childStore.userDetail.firstName}
            </p>
            <p className="text-center font-['Poppins'] text-sm leading-[1.4] text-[rgba(109,109,109,1)]">
              Student
            </p>
          </div>
        </div>
      </div>
      <Input
        onChange={(passCode) => {
          setPassCode(+passCode);
        }}
        type="passcode"
        placeholder="4-digit passcode"
      />
      <ButtonPrimary
        onClick={() => {
          toast.promise(submitChildDetails(), {
            loading: "Checking Child Passcode",
            error: (e: any) => e.message,
            success: "Logged In!",
          });
        }}
      >
        Submit
      </ButtonPrimary>
      <div className="flex justify-center py-4 px-2">
        <button
          onClick={() => navigate("/parent/child_selection")}
          className="text-brij-DarkGrey hover:text-brij-Black"
        >
          BACK
        </button>
      </div>
      <div className="flex justify-center py-4 px-2">
        <button
          onClick={() => {
            setOpenChangePassDialog(true);
          }}
          className="text-brij-DarkGrey hover:text-brij-Black"
        >
          Change or Forgot Passcode
        </button>
      </div>
    </>
  );
});
